import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Types */
interface UseSwrSignOutProps {
  successCallback?: () => void;
  errorCallback?: () => void;
}

interface SuccessResponse {
  success: boolean;
}

/**
 * @description Hook for signing out the user. It just signs out from Auth.js, not from Symfony.
 * - `successCallback` - Callback function to execute on successful sign out.
 * - `errorCallback` - Callback function to execute on error during sign out.
 */
export const useSwrSignOut = (props: UseSwrSignOutProps) => {
  const { successCallback, errorCallback } = props;
  const baseUrl = process.env.NEXT_PUBLIC_APP_API_URL || '';

  return useSwrMutationApi<SuccessResponse, undefined>({
    url: `${baseUrl}/api/auth/sign-out`,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => successCallback?.(),
      onError: () => errorCallback?.(),
    },
  });
};
